// extracted by mini-css-extract-plugin
export default {"main-banner":"umaKFxq5","banner-slider":"lLv1Zlr0","banner-slide":"FHxfVaPH","banner-background":"mm8A3rdT","banner-overlay":"QrqdLsGo","banner-btn":"LEdmo0LZ"};